import React from "react";
import { Link } from "react-router-dom";
import CommonFooter from "../../../../../core/common/footer/commonFooter";

const tableData = [
  {
    id: 1,
    item: "Service Charges for Gobler Barcode Printer",
    qty: 1,
    rate: "₹1,500.00",
    tax: "SGST 9.00%, CGST 9.00%",
    amount: "₹1,500.00",
  },
  {
    id: 2,
    item: "Installation Charges for Printer",
    qty: 2,
    rate: "₹1,000.00",
    tax: "SGST 9.00%, CGST 9.00%",
    amount: "₹2,000.00",
  },
  // Add more rows as necessary
];

const ViewEstimate = () => {




  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="container mt-4">
          <div className="d-flex align-items-center mb-3">
            <div>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb d-flex justify-content-between w-100">
                  <div className="d-flex align-items-center">
                    <li className="breadcrumb-item">
                      <Link to="/crm/estimates">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item mb-0" aria-current="page">
                      View Estimate
                    </h4>
                  </div>
                </ol>
              </nav>
            </div>
            <div className="ms-auto">
              
              <Link className="btn btn-info me-2">
                <i className="fas fa-download me-2"></i> Pdf
              </Link>
              <Link className="btn btn-danger me-2">
                <i className="fas fa-x me-2"></i> Decline
              </Link>
              <Link className="btn btn-success">
                <i className="fas fa-check me-2"></i> Accept
              </Link>
              <Link to="/crm/estimates" className="btn btn-secondary me-2">
                <i className="ti ti-arrow-left me-1"></i>Back
              </Link>
            </div>
          </div>

          {/* Main Layout (Table on the left, Content on the right) */}
          <div className="card shadow">
            {/* Header Section */}

            {/* Body Section */}
            <div className="card-body" style={{ padding: "4rem" }}>
              <div className="row">
                <div className="col-md-6">
                  <h4 className="mb-0">EST-2660</h4>
                  <h6>Perennial Code IT Consultants Pvt. Ltd</h6>
                  <p className="mb-1">Vidya Nagar, Hyderabad Telangana</p>
                  <p className="mb-1">INDIA 500044</p>
                  <p className="mb-1">
                    GSTIN: <strong>36AAHCP8044R1ZM</strong>
                  </p>
                  <p>Off: +91 4048513363, +91 8297230010 (M)</p>
                </div>

                {/* Receiver Details */}
                <div className="col-md-6 text-end">
                  <h6>To:</h6>
                  <p className="mb-1">Sree Vaari Silks</p>
                  <p className="mb-1">Habsiguda, Telangana, India</p>
                  <p className="mb-1">Hyderabad TS</p>
                  <p>
                    GSTIN: <strong>36AVKPG0403A1ZE</strong>
                  </p>
                </div>
              </div>

              <hr />

              {/* Estimate Dates */}
              <div className="d-flex justify-content-between">
                <p>
                  Estimate Date: <strong>26/03/2025</strong>
                </p>
                <p>
                  Expiry Date: <strong>10/04/2025</strong>
                </p>
              </div>

              {/* Table Section */}
              <div className="table-responsive">
                <table className="table table-bordered mt-3">
                  <thead className="table-striped">
                    <tr>
                      <th>#</th>
                      <th>Item</th>
                      <th>Qty</th>
                      <th>Rate</th>
                      <th>Tax</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((data) => (
                      <tr key={data.id}>
                        <td>{data.id}</td>
                        <td>{data.item}</td>
                        <td>{data.qty}</td>
                        <td>{data.rate}</td>
                        <td>{data.tax}</td>
                        <td>{data.amount}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Amount Summary with custom HR */}
              <hr style={{ border: "1px solid #ddd", margin: "20px 0" }} />

              <div className="text-end">
                <p>Sub Total: ₹1,500.00</p>
                <p>SGST (9.00%): ₹135.00</p>
                <p>CGST (9.00%): ₹135.00</p>
                <h5>Total: ₹1,770.00</h5>
              </div>

              <hr />

              {/* Note and Bank Details Section */}
              <div className="mt-3">
                <h6>
                  <strong>Note:</strong>
                </h6>
                <p>Payment Terms: 100% Advance.</p>

                <h6>
                  <strong>Axis Bank Details:</strong>
                </h6>
                <p className="mb-1">
                  Account Name: Perennial Code IT Consultants Pvt Ltd
                </p>
                <p className="mb-1">Bank: Axis Bank, Nallakunta, Hyderabad</p>
                <p className="mb-1">Account# 914020041433504</p>
                <p className="mb-1">IFC Code: UTIB0001381</p>
              </div>

              {/* Terms & Conditions Section */}
              <div className="mt-3">
                <h6>
                  <strong>Terms & Conditions:</strong>
                </h6>
                <p>
                  Site visits will not be covered under AMC & Site Visits are
                  Chargeable.
                </p>
              </div>
            </div>
          </div>
        </div>
           <CommonFooter/>
      </div>
    </div>
  );
};

export default ViewEstimate;
